module.exports = __webpack_public_path__ + "img/mascot-1.a6b5d36d.png";